// extracted by mini-css-extract-plugin
export var footer = "_mz-5";
export var fulfillmentInput = "_mz-0";
export var shipDateInput = "_mz-1";
export var shipmentModal = "_mz-2";
export var shipmentModalContent = "_mz-3";
export var tableContainer = "_mz-4";